import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {ParticleService} from '@core/services/particle.service';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {TreatyButtonCellComponentComponent} from "../cell-components/treaty-button-cell-component/treaty-button-cell-component.component";
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";
import {TreatyCbcReportsCellComponentComponent} from "../cell-components/treaty-cbc-reports-cell-component/treaty-cbc-reports-cell-component/treaty-cbc-reports-cell-component.component";

@Component({
    standalone: false,
    selector: 'particle-treaty-beps-cbc-exchange-status',
  templateUrl: './treaty-beps-cbc-exchange-status.component.html',
  styleUrls: ['./treaty-beps-cbc-exchange-status.component.scss']
})
export class TreatyBepsCbcExchangeStatusComponent implements OnInit {
  sourceKey: string;
  unSubscribe$ = new Subject<void>();
  invalidateSubject: InvalidateSubject;

  constructor(private particleService: ParticleService,
              private router: Router,
              private particleStore: Store<ParticleState>,
              private commandService: CommandService,
              private fuseSplashScreenService: FuseSplashScreenService,
              iconRegistry: MatIconRegistry,
              sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon('edit-icon', sanitizer.bypassSecurityTrustResourceUrl('http://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/icons/svgs/edit-icon.svg'));
    this.particleService.registerCellComponent('TreatyCellComponentComponent', TreatyButtonCellComponentComponent);
    this.particleService.registerCellComponent('TreatyCbcReportsCellComponentComponent', TreatyCbcReportsCellComponentComponent);
    this.sourceKey = 'BEPS-CbC-Exchange-Status';
  }

  ngOnInit() {
  }

  onGridCellValueChange($event: any) {

  }
}
